export default __webpack_public_path__ + "static/media/4.99f6b87c.png";